import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import GetStaffs                                    from "../../../application/usecase/staff/GetStaffs";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import StaffList                                    from "../../components/staff/StaffList";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  getStaffs: GetStaffs;
}

class StaffsContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "スタッフ一覧",
    };

    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.getStaffs.execute();
  }

  protected renderInternal(): ReactNode {
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "スタッフ一覧",
                path: "/staffs"
              }
            ]
          }/>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </TopSection>

        <TopSection>
          <BackHistoryButton path="/setting"/>
        </TopSection>

        <TopSection>
          <p>スタッフ用のアカウントを作成することができます。</p>
          <p>ここで作成したアカウントはスタッフ用の権限になります。</p>
        </TopSection>

        <section>
          <StaffList/>
        </section>
      </>
    );
  }

}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getStaffs: new GetStaffs(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffsContainer);
